// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _getV1Dashboard = async (url: string, request: Types.GetV1DashboardRequest): Promise<Types.GetV1DashboardResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardRequest)[]  = ['filter_type']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Dashboard: Api['getV1Dashboard'] = async (request: Types.GetV1DashboardRequest): Promise<Types.GetV1DashboardResponses> => {
  return await _getV1Dashboard(baseUrl, request)
}
const _getV1DashboardUserActivity = async (url: string, request: Types.GetV1DashboardUserActivityRequest): Promise<Types.GetV1DashboardUserActivityResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardUserActivityRequest)[]  = ['filter_type']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/user-activity?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardUserActivity: Api['getV1DashboardUserActivity'] = async (request: Types.GetV1DashboardUserActivityRequest): Promise<Types.GetV1DashboardUserActivityResponses> => {
  return await _getV1DashboardUserActivity(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    getV1Dashboard: _getV1Dashboard.bind(url, ...arguments),
    getV1DashboardUserActivity: _getV1DashboardUserActivity.bind(url, ...arguments)
  }
}